export default __webpack_public_path__ + "static/media/dislike.7b8f006a.svg";